<template>
  <div>
      <b-row>
        <b-col cols="12">
          <b-row>
            <b-col cols="12">
              <div class="flex h-full" style="cursor: pointer;">
                <div :class="[(currentRoute === 'forms') ? 'menu-item-active' : 'menu-item']" @click="select('forms')">
                  <div class="flex mt-6">
                    <div style="font-size: 14px">CopyrightAssignmentTransfer Information</div>
                  </div>
                </div>
                <div :class="[(currentRoute === 'attachments') ? 'menu-item-active' : 'menu-item']" @click="select('attachments')">
                  <div class="flex mt-6">
                    <div style="font-size: 14px">Attachments</div>
                  </div>
                </div>
                <div :class="[(currentRoute === 'messages') ? 'menu-item-active' : 'menu-item']" @click="select('messages')">
                  <div class="flex mt-6">
                    <div style="font-size: 14px">Messages</div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <CopyrightAssignmentTransferFormsDetails :application="application" v-if="currentRoute === 'forms'"/>
              <CopyrightAssignmentTransferFormFilesDetails :application="application" v-if="currentRoute === 'attachments'"/>
              <CopyrightAssignmentTransferDetailsMessages :id="application.id" v-if="currentRoute === 'messages'"/>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
  </div>
</template>

<script>
import CopyrightAssignmentTransferFormsDetails
  from "@/views/home/services/copyright-assignment-transfer/submissions/components/CopyrightAssignmentTransferFormsDetails.vue";
import CopyrightAssignmentTransferFormFilesDetails
  from "@/views/home/services/copyright-assignment-transfer/submissions/components/CopyrightAssignmentTransferFormFilesDetails.vue";
import CopyrightAssignmentTransferDetailsMessages
  from "@/views/home/services/copyright-assignment-transfer/submissions/CopyrightAssignmentTransferDetailsMessages.vue";
export default {
  name: "CopyrightAssignmentTransferPopupDetails",
  components: {
    CopyrightAssignmentTransferDetailsMessages,
    CopyrightAssignmentTransferFormFilesDetails,
    CopyrightAssignmentTransferFormsDetails
  },
  props:{
    application:Object
  },
  data(){
    return{
      currentRoute: "forms",
    }
  },
  methods:{
    select(route){
      this.currentRoute = route
    },
    reset(data){
      this.application = data
    }
  },
}
</script>

<style scoped>
th, td{
  font-size: 12px;
}
</style>
